<template>
    <div>
        <inserir-atualizar-despesa-form 
            :acao="acao"
            :opcoes="opcoes"  
            :fornecedor="fornecedor"
            :despesa="despesa"
            @pesquisarFornecedor="pesquisarFornecedor($event)"  
            @inserir="inserirDespesa($event)"
            @atualizar="atualizarDespesa($event)"
            :erros="erros"
        >
            <template slot="botoes">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </inserir-atualizar-despesa-form>
        <router-view></router-view>
    </div>
</template>

<script>
import InserirAtualizarDespesaForm from '@/app/despesasgerais/componentes/despesas/InserirAtualizarDespesaForm.vue';
import DespesasServicos from './DespesasServicos';

export default {
    components: {
        InserirAtualizarDespesaForm
    },

    data() {
        return {
            opcoes: {},
            fornecedor: {},
            despesa: null,
            erros: []
        }
    },

    methods: {
        obterDespesa() {
            this.$store.dispatch('addRequest')
            DespesasServicos.obterPorId(this.$route.params.despesaId).then(response => {
                if (response) {
                    if (response.success) {
                        this.despesa = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterDespesaOpcoes() {
            this.$store.dispatch("addRequest")
            DespesasServicos.obterDespesasOpcoes().then(response => {
                if (response) {
                    if (response.success) {
                        this.opcoes = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch("removeRequest")
            })
        },

        pesquisarFornecedor(cpfcnpj) {
            this.$store.dispatch("addRequest")
            DespesasServicos.obterFornecedor(cpfcnpj).then(response => {
                if (response) {
                    if (response.success) {
                        this.fornecedor = response.data
                    } else {
                        this.$toast.error(
                            "Não foi possivel obter o fornecedor",
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch("removeRequest")
            })
        },

        inserirDespesa(despesaDto) {
            this.$store.dispatch("addRequest")
            DespesasServicos.inserirDespesa(despesaDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Despesa inserida com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.detalharDespesa(response.data)
                    } else {
                        this.erros =  response.errors
                    }
                }
                this.$store.dispatch("removeRequest")
            })
        },
    
        atualizarDespesa(despesaDto) {
            this.$store.dispatch("addRequest")
            DespesasServicos.atualizarDespesa(despesaDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Despesa atualizada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.detalharDespesa(response.data)
                    } else {
                        this.erros =  response.errors
                    }
                }
                this.$store.dispatch("removeRequest")
            })
        },

        detalharDespesa(id) {
            this.$router.push({
                name: `DespesasGerais_Requisitantes_Despesas_Detalhar`,
                params: {
                    despesaId: id
                }
            })
        }
    },

    created() {
        this.obterDespesaOpcoes()
        if (this.acao == 'ATUALIZAR') {
            this.obterDespesa()
        }
    },  

    computed: {
        acao() {
            return this.$route.name === 'DespesasGerais_Requisitantes_Despesas_Inserir' ? 
                'INSERIR' : 'ATUALIZAR'  
        }
    }
}

</script>